import React from 'react'
import { Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import PermissionWrapper from '../../../auth/PermissionWrapper';
import ConfirmButton from '../../Modal/ConfirmButton';

class TimeTrackingStandardRow extends React.Component {


    formatAMPM = (date) => {
        this.props.info('TimeTrackingStandardRow.js/formatAMPM (date)', date);
        if (date == null || date === '') return "";
        var [hours, minutes] = date.split(':').map(item => parseInt(item));
        // var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    displayMonth = (date) => {
        this.props.info('TimeTrackingStandardRow.js/displayMonth (date)', date);
        const [year, month, day] = date.split('-').map(item => parseInt(item));
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return this.props.daily ? months[month - 1] + ' ' + day + ', ' + year : months[month - 1] + ' ' + year;
    }

    render = () => {
        this.props.info('TimeTrackingStandardRow.js/render');
        return (
            <tr>
                <td>
                    {this.displayMonth(this.props.tt.date)}{this.props.tt.employee != null && this.props.tt.employee[0] != null ? <><br />{this.props.tt.employee[0].lastName}, {this.props.tt.employee[0].firstName} </> : <></>}
                </td>
                <td>
                    {this.props.tt.beginTimestampAdjusted != null && this.props.tt.beginTimestampAdjusted !== this.props.tt.beginTimestamp ? <>{this.formatAMPM(this.props.tt.beginTimestampAdjusted)} <span className='text-muted font-italic'>{' (' + this.formatAMPM(this.props.tt.beginTimestamp) + ' ' + this.props.tt.timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.formatAMPM(this.props.tt.beginTimestamp)}
                </td>
                <td>
                    {this.props.tt.endTimestampAdjusted != null && this.props.tt.endTimestampAdjusted !== this.props.tt.endTimestamp ? <>{this.formatAMPM(this.props.tt.endTimestampAdjusted)} <span className='text-muted font-italic'>{' (' + this.formatAMPM(this.props.tt.endTimestamp) + ' ' + this.props.tt.timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.formatAMPM(this.props.tt.endTimestamp)}
                </td>
                <td>
                    {this.props.tt.duration}
                </td>
                <td>
                    {<Button color="primary" onClick={() => this.props.onSetEdit(this.props.tt, this.props.workflowId)}>
                        <FontAwesomeIcon icon={faEdit} />
                    </Button>}
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} allowedPermission="Delete Task Time Entry">
                        <ConfirmButton color="danger" onClick={() => this.props.onHandleDelete(this.props.tt.id)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    {this.props.tt.isComplete && <FontAwesomeIcon className='ml-3 text-success' icon={faCheck} />}
                </td>
            </tr>

        )
    }
}

export default TimeTrackingStandardRow;